module.exports = __webpack_public_path__ + "img/loading.b41d253b.svg";